import {Button, Card, Col, FormControl, FormGroup, Row} from 'react-bootstrap';
import DateTime from 'react-datetime';

const PpcSearch = (props) => {
  const doSearch = (e) => {
    if (e.key === 'Enter') {
      props.onSearch();
    }
  };

  return (
    <Card className="ppc-management-filter admin-search-filter">
      <Card.Body>
        <Row>
          <Col md={6}>
            <FormGroup>
              <FormControl
                onChange={props.onInputChange}
                onKeyPress={doSearch}
                placeholder="Enter user id, email, mobile, first name or last name"
                value={props.searchValue}
              />
            </FormGroup>
          </Col>
          <Col md={3}>
            <FormGroup>
              <DateTime
                closeOnSelect
                dateFormat="DD/MM/YYYY"
                inputProps={{
                  placeholder: 'Opt in date from'
                }}
                onChange={props.onDateFromChange}
                timeFormat={false}
                value={props.dateFromValue}
              />
            </FormGroup>
          </Col>
          <Col md={3}>
            <FormGroup>
              <DateTime
                closeOnSelect
                dateFormat="DD/MM/YYYY"
                inputProps={{
                  placeholder: 'Opt in date to'
                }}
                onChange={props.onDateToChange}
                timeFormat={false}
                value={props.dateToValue}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={6}>
          </Col>
          <Col className="actions" md={6}>
            <Button
              className="red-ghost-btn"
              onClick={props.onSearch}
            >
              Search
            </Button>

            <Button
              className="grey-ghost-btn"
              onClick={props.onClear}
            >
              Clear search/filters
            </Button>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default PpcSearch;
